module.exports = __webpack_public_path__ + "static/img/img4.c8b8e40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zone/img4.png
// module id = mxAR
// module chunks = 1